export const getDayAndMonthFromDate = (input) => {
	const date = new Date(input);
	const day = date.getDate().toString().padStart(2, "0");
	const month = (date.getMonth() + 1).toString().padStart(2, "0");
	const dateToReturn = `${day}.${month}`;
	return dateToReturn;
};
